export interface SSOState {
  redirectUrl: string | null;
  clientNonce?: string;
  ssoType: 'google' | 'microsoft';
}

export function parseStateParameter(stateQueryUrl: string | null): string | null {
  if (!stateQueryUrl) {
    return null;
  }

  try {
    const stateData: SSOState = JSON.parse(decodeURIComponent(stateQueryUrl));
    return stateData.redirectUrl || null;
  } catch (e) {
    console.error("Failed to parse state parameter:", e);
    return null;
  }
}

export function createStateParameter(redirectUrl: string | null, clientNonce: string | undefined, ssoType: 'google' | 'microsoft'): string {
  return encodeURIComponent(
    JSON.stringify({ redirectUrl, clientNonce, ssoType })
  );
}